// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-94b6e4ec] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  padding: 5.33333vw;\n}\n.box span[data-v-94b6e4ec] {\n  color: blue;\n}", ""]);
// Exports
module.exports = exports;
